module.exports = __webpack_public_path__ + "static/img/icon4.0037786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/icon4.png
// module id = S12S
// module chunks = 1